import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import $ from 'jquery';

gsap.registerPlugin(ScrollTrigger);

$(function() {

    ScrollTrigger.matchMedia({
      
      "(max-width: 599px)": function() {
        
        let fadeInElems = document.querySelectorAll("[data-fadeinmobile]");
        if( $( fadeInElems ).length ) {
          fadeInElems.forEach( ( elem, i ) => {
            gsap.set(fadeInElems, { opacity: 0 });
      
            ScrollTrigger.create({
              trigger: elem,
              start: "center 75%",
              markers: false,
              onEnter: () => gsap.to(elem, { opacity: 1, overwrite: 'auto'}),
            });
      
          });
        }
      },
            
      // desktop
      "(min-width: 960px)": function() {
        
        // HOME PAGE PINNED SECTION TIMELINE
        var home_timeline = document.querySelectorAll(".pin-one");

        if( $( home_timeline ).length ) {
          home_timeline.forEach( ( pin, i ) => {
            
            let mask = pin.querySelector(".panel .mask");
            let blurb_one = pin.querySelector(".panel .blurb-one");
            let blurb_two = pin.querySelector(".panel .blurb-two");
            let doorLeft = pin.querySelector(".panel.door-left");
            let doorRight = pin.querySelector(".panel.door-right");
            let cta = pin.querySelector(".panel.cta");
            let time = (pin.querySelectorAll(".panel").length) * 100;

            let tl = gsap.timeline({
              scrollTrigger: {
                trigger: pin,
                pin: true,
                scrub: true,
                start: "top top",
                end: "+=" + time + "% top+=1%",
                markers: false,
                toggleActions: "play pause play reset"
              }
            });

            tl.from(mask, {
                top: '50%',
                duration: 1
              }, "+=0.05"
            ).to(mask, {
                top: '0%',
                duration: 1
              }, "+=0.05"
            ).from(mask, {
                transform: 'scale(0.25)',
                duration: 1,
              }, "1"
            ).to(mask, {
                transform: 'scale(1)',
                duration: 1,
              }, "1"
            ).from(blurb_one, {
                opacity: 0,
                duration: 1,
              }, "1"
            ).to(blurb_one, {
                opacity: 1,
                duration: 1,
              }, "1"
            ).from(blurb_one, {
                opacity: 1,
                duration: 1,
              }, "2"
            ).to(blurb_one, {
                opacity: 0,
                duration: 1,
              }, "3"
            ).from(blurb_two, {
                opacity: 0,
                duration: 1,
              }, "3"
            ).to(blurb_two, {
                opacity: 1,
                duration: 1,
              }, "4"
            ).from(doorLeft, {
                transform: 'translateX(-100%)',
                duration: 1
              }, "5"
            ).to(doorLeft, {
                transform: 'translateX(0)',
                duration: 1
              }, "5"
            ).from(doorRight, {
                transform: 'translateX(100%)',
                duration: 1
              }, "5"
            ).to(doorRight, {
                transform: 'translateX(0)',
                duration: 1
              }, "5"
            ).from(cta, {
                transform: 'translateY(100%)',
                duration: 1
              }, "+=1.5"
            ).to(cta, {
                transform: 'translateY(0)',
                duration: 1
              }, "+=1.5"
            )
          });
        }

        // CAN PARALLAX
        const scrollSpeedAll = document.querySelectorAll("[data-scrollspeed]");

        if( $( scrollSpeedAll ).length ) {

          scrollSpeedAll.forEach( graphic => {
            gsap.set( graphic, { yPercent: -50 });
            gsap.from( graphic, { 
              yPercent: graphic.dataset.scrollspeed,
              scrollTrigger: {
                trigger: graphic,
                scrub: 1
              }
            })
          });
        }

        let home_filter_elem = document.querySelector(".home-filter");
        
        if ( $( home_filter_elem ).length ) {
          
          let home_filter_text = home_filter_elem.querySelector(".filter-text");
          let home_filter_bg = home_filter_elem.querySelector(".filter-bg");

          let home_filter = gsap.timeline({
            scrollTrigger: {
              trigger: home_filter_elem,
              pin: true,
              scrub: 0.5,
              start: "center center",
              markers: false,
              end: "+=1500 center",
              // toggleActions: "play pause play reset"
            }
          });

          home_filter.from( home_filter_text, {
              transform: 'translateY(50%)',
              duration: 2
            }, 
          ).to( home_filter_text, {
              transform: 'translateY(0)',
              duration: 2
            }, 
          )
          .from( home_filter_bg, {
              opacity: 0,
              duration: 3,
            }, 
          ).to( home_filter_bg, {
              opacity: 0.6,
              duration: 3
            }
          )
        }
  
        var home_timeline_2 = document.querySelectorAll(".pin-two");

        if( $( home_timeline_2 ).length ) {
          home_timeline_2.forEach( ( pin, i ) => {
            
            let mask = pin.querySelector(".panel .mask");
            let blurb = pin.querySelector(".panel .blurb");
            let doorLeft = pin.querySelector(".panel.door-left");
            let doorRight = pin.querySelector(".panel.door-right");
            let time = ( pin.querySelectorAll(".panel").length ) * 100;

            let tl = gsap.timeline({
              scrollTrigger: {
                trigger: pin,
                pin: true,
                scrub: true,
                start: "top top",
                end: "+=" + time + "% top+=1%",
                markers: false,
                toggleActions: "play pause play reset"
              }
            });

            tl.from( mask, {
                top: '50%',
                duration: 1
              }, "+=0.05"
            ).to( mask, {
                top: '0%',
                duration: 1
              }, "+=0.05"
            ).from( mask, {
                transform: 'scale(0.25)',
                duration: 1,
              }, "1"
            ).to( mask, {
                transform: 'scale(1)',
                duration: 1,
              }, "1"
            ).from( blurb, {
                opacity: 0,
                duration: 1,
              }, "1"
            ).to( blurb, {
                opacity: 1,
                duration: 1,
              }, "1"
            ).from( doorLeft, {
                transform: 'translateX(-100%)',
                duration: 1
              }, "3"
            ).to( doorLeft, {
                transform: 'translateX(0)',
                duration: 1
              }, "3"
            ).from( doorRight, {
                transform: 'translateX(100%)',
                duration: 1
              }, "3"
            ).to( doorRight, {
                transform: 'translateX(0)',
                duration: 1
              }, "3"
            )
          });
        }
      }
    });

    if( $( '.video-anim' ).length ) {
      setTimeout( () => {
        ScrollTrigger.refresh();
      }, 2000 )
    }

    // home page background color change
    let scrollColorElems = document.querySelectorAll("[data-scrollcolor]");

    if( $( scrollColorElems ).length ) {

      scrollColorElems.forEach((colorSection, i) => {
        
        let defaultColor = scrollColorElems[0].dataset.scrollcolor;
        let prevColor = i === 0 ? defaultColor : scrollColorElems[i - 1].dataset.scrollcolor;

        ScrollTrigger.create({
          trigger: colorSection,
          start: "top top",
          markers: false,
          onEnter: () => gsap.to( ".bg-fade", { backgroundColor: colorSection.dataset.scrollcolor, overwrite: 'auto' } ),
          onLeaveBack: () => gsap.to( ".bg-fade", { backgroundColor: prevColor, overwrite: 'auto' } )
        });
      });
    }

    // home page right side fixed cta
    var scrollCaption = document.querySelectorAll( "[data-caption]" );
    var scrollCaptionElem = document.querySelector( ".side-cta" );

    if( $( scrollCaption ).length ) {

      scrollCaption.forEach((elem, i) => {
        
        let data = JSON.parse(elem.dataset.caption);
        
        ScrollTrigger.create({
          trigger: elem,
          start: "top top",
          markers: false,
          onEnter() {
            scrollCaptionElem.innerHTML = '+' + data.text;
            scrollCaptionElem.setAttribute( "href", data.link );
          },
          onLeaveBack() {
            scrollCaptionElem.innerHTML = '+' + data.text;
            scrollCaptionElem.setAttribute( "href", data.link );
          }
        });
      });
    }

    // fade in elements
    let fadeInElems = document.querySelectorAll( "[data-fadein]" );

    if( $( fadeInElems ).length ) {
      fadeInElems.forEach((elem, i) => {
        gsap.set(fadeInElems, { opacity: 0 });

        ScrollTrigger.create({
          trigger: elem,
          start: "center 75%",
          markers: false,
          onEnter: () => gsap.to( elem, { opacity: 1, overwrite: 'auto' } ),
        });
      });
    }

    // home page teal section color change
    let feel_safe = document.querySelector(".color-change");

    if( $( feel_safe ).length ) {
      ScrollTrigger.create({
        trigger: feel_safe,
        start: "top +=25%",
        markers: false,
        onEnter: () => gsap.to(".bg-teal", { backgroundColor: "#FFFFFF", overwrite: 'auto'}),
        onLeaveBack: () => gsap.to(".bg-teal", { backgroundColor: "#669599", overwrite: 'auto'})
      });
    }

    // staggered titles component animation
    if( $( '.staggered-titles' ).length ) {

      let staggered_titles = gsap.timeline({
        scrollTrigger: {
          trigger: ".staggered-titles",
          pin: true,
          scrub: 1,
          start: "top top",
          end: "+=300% top+=1%",
          toggleActions: "play pause play reset"
        }
      });

      staggered_titles.from(".thumb img", {
          opacity: 0,
          duration: 1,
          scale: 0.75
        }
      )
      .from(".thumb p", {
          opacity: 0,
          duration: 1,
          stagger: 1
        }
      )
      .to(".thumb p", {
          opacity: 1,
          duration: 1,
          stagger: 1
        }
      )
    }

    // points section
    let points = document.querySelectorAll(".point");

    if( $( points ).length ) {
      points.forEach( ( elem, i ) => {
        var point_index = ( i + 1 );
        
        ScrollTrigger.create({
          trigger: elem,
          start: "center 75%",
          markers: false,
          onEnter() { elem.parentNode.dataset.point = point_index; },
          onLeaveBack() { elem.parentNode.dataset.point = point_index; }
        });
      });
    }
    if( $( '.slick-track' ).length ) {
      setTimeout( () => {
        ScrollTrigger.refresh();
      }, 1500 )
    }

})
